import { useEffect, useState } from 'react';

const useImagePasteHandler = () => {
    const [image, setImage] = useState<File | null>(null);

    const handlePaste = (event: ClipboardEvent) => {
        if (!event.clipboardData) return;

        const imageFile = Array.from(event.clipboardData.items)
            .find((item) => item.type.startsWith('image'))
            ?.getAsFile();

        if (imageFile) {
            setImage(imageFile);

            // Prevent filename paste into input
            event.preventDefault();
        }
    };

    useEffect(() => {
        document.addEventListener('paste', handlePaste);

        return () => document.removeEventListener('paste', handlePaste);
    }, []);

    return image;
};

export default useImagePasteHandler;
